const LoadingSpinner: React.FC<{ isRed?: boolean }> = ({ isRed }) => {
  return (
    <div className="center-v">
      <div
        className={`spinner-border ${isRed ? "text-danger" : "text-gold"} `}
        role="status"
      >
        <span className="sr-only"></span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
